import { Routes, RouterModule } from '@angular/router';

//Route for content layout with sidebar, navbar and footer
export const Map_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('../../map/map.module').then(m => m.MapModule),

  }
];
